import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {
    document_instance: null,
    currentApplicationId: null,
    background_screening: null,
    identity_verification: null,
    bm_credentials: null,
    application: null,
    guarantor: null,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
